import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['Retrieve Account', 'Application Form', 'Summary', 'Confirmation'];
}

/* function getStepContent(step) {
  switch (step) {
    case 0:
      return 'Retrieve bill account'
    case 1:
      return 'Complete Application'
    case 2:
      return 'Summary'
    case 3:
      return 'Confirmation'
    default:
      return 'Unknown step'
  }
} */

export default function HorizontalStepper(props) {
  const classes = useStyles();
  const steps = getSteps();

  console.log('stepper', props);
  return (
    <div className={classes.root}>
      <Stepper activeStep={props.activeStep} alternativeLabel>
        {steps.map(label => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}

HorizontalStepper.propTypes = {
  activeStep: PropTypes.number,
};
